const DefaultPageSize = 100;
export var ApiPageStateOrderByDir;
(function (ApiPageStateOrderByDir) {
    ApiPageStateOrderByDir["DESC"] = "DESC";
    ApiPageStateOrderByDir["ASC"] = "ASC";
})(ApiPageStateOrderByDir || (ApiPageStateOrderByDir = {}));
;
;
export function ApiPageState_init(pageName, apiResult) {
    var _a;
    let r = {
        currentPage: 1,
        expectedTotal: ((_a = apiResult === null || apiResult === void 0 ? void 0 : apiResult.pageInfo) === null || _a === void 0 ? void 0 : _a.totalCount) ? apiResult.pageInfo.totalCount : -1,
        limit: 100,
        offset: 0,
        orderbycol: ["updated_at"],
        orderbydir: ApiPageStateOrderByDir.DESC
    };
    return r;
}
